import {
  DATADOG_INTEGRATION_DESCRIPTION,
  DATADOG_PROFILE_NAME,
  EMAIL_PROFILE_NAME,
  JIRA_PROFILE_NAME,
  SERVICE_NOW_PROFILE_NAME,
  SLACK_PROFILE_NAME,
  TEAMS_PROFILE_NAME,
} from "app/views/notifications/integrations/consts";

export type IntegrationProfile =
  | typeof SLACK_PROFILE_NAME
  | typeof EMAIL_PROFILE_NAME
  | typeof JIRA_PROFILE_NAME
  | typeof SERVICE_NOW_PROFILE_NAME
  | typeof TEAMS_PROFILE_NAME
  | typeof DATADOG_PROFILE_NAME;

interface IntegrationMeta {
  targetUrl: string;
  title: string;
  tooltipText?: string;
}

export function useIntegrations() {
  const integrations = new Map<IntegrationProfile, IntegrationMeta>([
    [SLACK_PROFILE_NAME, { targetUrl: "slack", title: "Slack" }],
    [EMAIL_PROFILE_NAME, { targetUrl: "email", title: "Email" }],
    [JIRA_PROFILE_NAME, { targetUrl: "jira", title: "Jira" }],
    [
      SERVICE_NOW_PROFILE_NAME,
      { targetUrl: "service-now", title: "ServiceNow" },
    ],
    [TEAMS_PROFILE_NAME, { targetUrl: "teams", title: "Microsoft Teams" }],
    [
      DATADOG_PROFILE_NAME,
      {
        targetUrl: "datadog",
        title: "Datadog",
        tooltipText: DATADOG_INTEGRATION_DESCRIPTION,
      },
    ],
  ]);

  return integrations;
}
